import { render, staticRenderFns } from "./XhInput.vue?vue&type=template&id=5ad21d70&scoped=true"
import script from "./XhInput.vue?vue&type=script&lang=js"
export * from "./XhInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad21d70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ad21d70')) {
      api.createRecord('5ad21d70', component.options)
    } else {
      api.reload('5ad21d70', component.options)
    }
    module.hot.accept("./XhInput.vue?vue&type=template&id=5ad21d70&scoped=true", function () {
      api.rerender('5ad21d70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CreateCom/XhInput.vue"
export default component.exports